<template>
  <div
    class="app"
    :class="`current-scene-${currentScene}`"
  >
    <div class="stage">
      <div class="stage__padding">
        <div class="stage__inner">
          <button
            class="scene__nav scene__nav--next button"
            @click="navigate('next')"
            v-if="!beginButton && currentScene !==3 && currentScene !== 4 && currentScene !== 6 && currentScene !== 7 && currentScene !==10 && currentScene !==11"
          >
            <span class="scene__nav-inner">{{ nextButtonText }}</span>
          </button>
          <button
            class="scene__nav scene__nav--next2 button"
            @click="navigate('next2')"
            v-if="!beginButton && (currentScene === 4 || currentScene === 7 || currentScene === 11)"
          >
            <span class="scene__nav-inner">{{ nextButtonText }}</span>
          </button>
          <button
            class="mute"
            :class="{
              'muted': muted
            }"
            @click="toggleMute()"
          >toggle mute</button>
          <button
            class="scene__begin button"
            @click="beginClicked()"
            v-if="beginButton"
          >Begin</button>
          <div
            class="scene scene-1"
            :class="{
              'active': currentScene === 1,
              'active-play': currentScene === 1 && !beginButton,
              'hush-arm': currentScene === 1 && ((trackTime >= .3 && trackTime < 3.3) || (trackTime >= 22.75 && trackTime < 25.75))
            }"
          >
            <h1 class="scene-1__title">Secret Codes</h1>
            <div class="scene-1__text">
              <p>Shhhh. Children hush. Cousin Ned and Cousin Nickel live over there on Cherokee Plantation in South Carolina. The two of them want to escape the harsh life on this plantation.</p>
              <p>Enslaved Africans were not allowed to talk to each other in public places so they had to find secret ways to communicate to one another. Hush children. Shhhh.</p>
            </div>
            <PearlieSue
              :speak-duration= "[2000, 25000]"
              :left-arm-point="true"
              ref="pearlieSueScene1"
            ></PearlieSue>
          </div>
          <div
            class="scene scene-2"
            :class="{
              'active': currentScene === 2
            }"
          >
            <h2 class="scene__title">Hidden Message</h2>
            <div class="scene-2__workers"></div>
            <div class="scene-2__text">
              <p>When the Africans wanted to talk to each other and the master was around, they had to sing songs while they worked.  See these songs were called work songs but they were really secret code songs because they had a hidden message in them.</p>
              <p>The overseer thought they were singing religious things about Jesus and all of that but they had a hidden meaning in them about escaping from the plantation.</p>
            </div>
          </div>
          <div
            class="scene scene-3"
            :class="{
              'active': currentScene === 3
            }"
          >
            <h2 class="scene__title">Secretly Singing</h2>
            <Choir
              ref="choirScene3"
            ></Choir>
            <div class="scene-3__text">
              <p>Can you help Cousin Ned and Cousin Nickel figure out the hidden meaning of the song? Listen good now!</p>
            </div>
            <div class="scene-3__multiple-choice">
              <p>The enslaved Africans were secretly singing about __________.</p>
              <ol>
                <li class="optionA" @click="navigate('next')"><button>stealing</button></li>
                <li class="optionB" @click="navigate('next2')"><button>running away</button></li>
                <li class="optionC" @click="navigate('next')"><button>going to heaven</button></li>
              </ol>
            </div>
          </div>
          <div
            class="scene scene-4"
            :class="{
              'active': currentScene === 4,
              'hush-arm': currentScene === 4 && trackTime >= 14 && trackTime < 17
            }"
          >
            <h2 class="scene__title">Almost Right- Running Away</h2>
            <div class="scene-4__text">
              <p>Oh, you were almost right. I tell you, they were secretly singing about RUNNING AWAY.</p>
              <p>Now the first part of the plan was to let everybody but the master know that Ned and Cousin Nickel were going to escape tonight. Shhh. They just need to know the right way to go to find freedom. That means you give them directions. Remember now, everything has to be done in secret.</p>
            </div>
            <Compass
              :compass-duration= "[16000,9999999999999999999]"
              ref="compassScene4"
            ></Compass>
            <PearlieSue
              :speak-duration= "[10, 26000]"
              :left-arm-point="true"
              ref="pearlieSueScene4"
            ></PearlieSue>
          </div>
          <div
            class="scene scene-5"
            :class="{
              'active': currentScene === 5,
              'hush-arm': currentScene === 5 && trackTime >= 18 && trackTime < 21,
            }"
          >
            <h2 class="scene__title">Chose Right- Running Away</h2>
            <div class="scene-5__text">
              <p>You chose the right thing.  B is the answer.  Boy you sure are smart!  I tell you, they were secretly singing about RUNNING AWAY.</p>
              <p>Now the first part of the plan was to let everybody but the master know that Ned and Cousin Nickel were going to escape tonight. Shhh. They just need to know the right way to go to find freedom. That means you give them directions. Remember now, everything has to be done in secret.</p>
            </div>
            <Compass
              :compass-duration= "[20000,9999999999999999999]"
              ref="compassScene5"
            ></Compass>
            <PearlieSue
              :speak-duration= "[10, 30000]"
              :left-arm-point="true"
              ref="pearlieSueScene5"
            ></PearlieSue>
          </div>
          <div
            class="scene scene-6"
            :class="{
              'active': currentScene === 6
            }"
          >
            <h2 class="scene__title">Hidden Directions</h2>
            <Choir ref="choirScene6"></Choir>
            <div class="scene-6__text">
              <p>Where did they have to go to find the hidden directions? Listen good now!</p>
            </div>
            <div class="scene-6__multiple-choice">
              <p class="instructions">Which object had the secret directions?</p>
              <ul>
                <li><button @click="navigate('next')"><div class="hat"></div><p>hat</p></button></li>
                <li><button @click="navigate('next')"><div class="cotton"></div><p>cotton</p></button></li>
                <li><button @click="navigate('next2')"><div class="quilt"></div><p>quilt</p></button></li>
              </ul>
            </div>
          </div>
          <div
            class="scene scene-7"
            :class="{
              'active': currentScene === 7,
            }"
          >
            <h2 class="scene__title">Almost Right- Quilt</h2>
            <div class="scene-7__quilt"></div>           
            <div 
              class="scene-7__quilt-circle"
              :class="{
                'highlight': (trackTime >=2.5 && trackTime < 2.6) || (trackTime >= 2.7 && trackTime < 2.8) || (trackTime >= 2.9 && trackTime < 3) || (trackTime >= 3.1 && trackTime < 3.2) || (trackTime >= 3.3 && trackTime < 3.4) || (trackTime >= 3.5 && trackTime < 3.6) || (trackTime >= 3.7 && trackTime < 3.8) || (trackTime >= 3.9 && trackTime < 4)
              }"
            ></div>
            <div class="scene-7__text">
              <p>Oh, you were almost right. The direction was sewn on the QUILT and they hung the quilt outside on the line or on the fence. Everybody knew what the hidden message was in the quilt except for the master or overseer. They didn't know. They just thought it was a pretty quilt.</p>
              <p>The North Star was used to guide the people through the woods to freedom. Some of the people escaped alone but many people escaped by way of the Underground Railroad.</p>
            </div>
          </div>
          <div
            class="scene scene-8"
            :class="{
              'active': currentScene === 8
            }"
          >
            <h2 class="scene__title">Chose Right- Quilt</h2>
            <div class="scene-8__quilt"></div>
            <div 
              class="scene-8__quilt-circle"
              :class="{
                'highlight': (trackTime >=11.0 && trackTime < 11.2) || (trackTime >= 11.3 && trackTime < 11.4) || (trackTime >= 11.5 && trackTime < 11.6) || (trackTime >= 11.7 && trackTime < 11.8) || (trackTime >= 11.9 && trackTime < 12) || (trackTime >= 12.1 && trackTime < 12.2) || (trackTime >= 12.3 && trackTime < 12.4) || (trackTime >= 12.5 && trackTime < 12.6)
              }"
            ></div>
            <div 
              class="scene-8__text"
              :class="{
                'active': trackTime <25
              }"
            >
              <p>Una, that means you.  You chose the QUILT.  That is so right, you got it right with your smart self again.  Oh, I'm proud of you.</p>
              <p class="second-paragraph">The direction was sewn on the QUILT and they hung the quilt outside on the line or on the fence. Everybody knew what the hidden message was in the quilt except for the master or overseer. They didn't know. They just thought it was a pretty quilt.</p>
            </div>
            <div 
              class="scene-8__text"
              :class="{
                'active': trackTime >=25
              }"
            >
              <p>The North Star was used to guide the people through the woods to freedom. Some of the people escaped alone but many people escaped by way of the Underground Railroad.</p>
              <div class="scene-8__text__north-star"></div>
            </div>
          </div>
          <div
            class="scene scene-9"
            :class="{
              'active': currentScene === 9
            }"
          >
            <h2 class="scene-9__title">What is the Underground Railroad?</h2>
            <div 
              class="scene-9__train"
              :class="{
                'active': trackTime <7
              }"
            ></div>
            <div 
              class="scene-9__house"
              :class="{
                'active': trackTime >=7
              }"
            ></div>
            <div class="scene-9__text">
              <p>The Underground Railroad was not a choo choo train. Not one that we ride on, but it was hidden pathways and safe houses that were hideouts for the enslaved Africans that were trying to get to freedom. See, they would rest at the safe houses and then they would move on until they finally reached up north to freedom.</p>
            </div>
            <PearlieSue
              :speak-duration= "[10, 20500]"
              :railroad-body= "true"
              ref="pearlieSueScene9"
            ></PearlieSue>
          </div>
          <div
            class="scene scene-10"
            :class="{
              'active': currentScene === 10
            }"
          >
            <h2 class="scene__title">Harriet Tubman</h2>
            <Choir ref="choirScene10"></Choir>
            <div class="scene-10__text">
              <p>Harriet Tubman was one of the most famous conductors of the Underground Railroad. Listen good now!</p>
            </div>
            <div class="scene-10__multiple-choice">
              <p>Harriet Tubman ______________.</p>
              <ol>
                <li class="optionA" @click="navigate('next')"><button>led an orchestra</button></li>
                <li class="optionB" @click="navigate('next')"><button>drove a train</button></li>
                <li class="optionC" @click="navigate('next2')"><button>guided people to freedom</button></li>
              </ol>
            </div>
            <div class="scene-10__overlay">
              <p class="button">Learn More</p>
              <div class="scene-10__overlay__box">
                <h2>Why were the enslaved Africans singing about Egypt in this song?</h2>
                <p>In the bible, Moses led the Israelites out of Egypt because they were in bondage.  In America, the enslaved Africans were just like the Israelites.  They were also in bondage.  Harriet Tubman was nicknamed "Moses".</p>
              </div>
            </div>
          </div>
          <div
            class="scene scene-11"
            :class="{
              'active': currentScene === 11
            }"
          >
            <h2 class="scene__title">Almost Right- Freedom</h2>
            <div class="scene-11__harriet-tubman"></div>
            <div class="scene-11__text">
              <p>Oh, you were almost right. That gal came back over 19 times to the South and helped to free over 300 other people including her mother and father.</p>
              <p>Each trip was more dangerous and difficult than the other but you know that girl never lost a passenger. Not one. She told them, "If you decide to turn back, I'll shoot you dead before I let you go back into slavery." And not one turned back because all of them made it to freedom.</p>
            </div>
            <PearlieSue
              :body-two="true"
              :speak-duration= "[10, 28000]"
              :thumbs-up="true"
              ref="pearlieSueScene11"
            ></PearlieSue>
          </div>
          <div
            class="scene scene-12"
            :class="{
              'active': currentScene === 12
            }"
          >
            <h2 class="scene__title">Chose Right- Freedom</h2>
            <div class="scene-12__harriet-tubman"></div>
            <div class="scene-12__text">
              <p>If una chose C, that be the right answer. Ohhh you so smart! That gal came back over 19 times to the South and helped to free over 300 other people including her mother and father.</p>
              <p>Each trip was more dangerous and difficult than the other but you know that girl never lost a passenger. Not one. She told them, "If you decide to turn back, I'll shoot you dead before I let you go back into slavery." And not one turned back because all of them made it to freedom.</p>
            </div>
            <PearlieSue
              :body-two="true"
              :speak-duration= "[10, 31000]"
              :thumbs-up="true"
              ref="pearlieSueScene12"
            ></PearlieSue>
          </div>
          <div
            class="scene scene-13"
            :class="{
              'active': currentScene === 13,
              'people-moving': currentScene === 13 && trackTime > 9 && trackTime < 21,
              'people-moved': currentScene === 13 && trackTime >= 21
            }"
          >

            <h2 class="scene-13__title">Thank You</h2>
            <div class="scene-13__states"></div>
            <div class="scene-13__states-label">
              <p class="yellow">Free States</p>
              <p class="orange">Non-free States</p>
            </div>
            <div class="scene-13__text">
              <p>Well, I thank you children for helping Cousin Ned and Cousin Nickel learn the <span>SECRET CODE</span> and escape to freedom. And baby when they escaped they had a song to sing.</p>
              <p>Oh When I Get There. They were talking about that Ohio River, Canada and New York up north to freedom.</p>
            </div>
            <PearlieSue
              :body-two="true"
              :speak-duration= "[10,23000]"
              :right-arm-point="true"
              ref="pearlieSueScene13"
            ></PearlieSue>
            <People></People>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import PearlieSue from '@/components/PearlieSue'
import Choir from '@/components/Choir'
import Compass from '@/components/Compass'
import People from '@/components/People'
export default {
  name: 'app',
  components: {
    PearlieSue,
    Choir,
    Compass,
    People
  },
  data () {
    return {
      choirTimeout: null
    }
  },
  computed: {
    ...mapState([
      'numScenes',
      'currentScene',
      'beginButton',
      'muted',
      'trackTime'
    ]),
    nextButtonText () {
      if (this.currentScene < this.numScenes) {
        return 'Next'
      } else {
        return 'End'
      }
    }
  },
  methods: {
    ...mapMutations([
      'HIDE_BEGIN_BUTTON',
      'RESET_TRACK_INTERVAL'
    ]),
    ...mapActions([
      'begin',
      'previousScene',
      'previous2Scenes',
      'nextScene',
      'next2Scenes',
      'toggleMute'
    ]),
    beginClicked () {
      this.begin()
      this.$refs.pearlieSueScene1.speak()
    },
    navigate (direction) {
      clearTimeout(this.choirTimeout)
      this.$refs[`choirScene3`].stop()
      this.$refs[`choirScene6`].stop()
      this.$refs[`choirScene10`].stop()
      if (direction === 'next') {
        this.nextScene()
      } else if (direction === 'next2') {
        this.next2Scenes()
      } else if (direction === 'previous2') {
        this.previous2Scenes()
      } else {
        this.previousScene()
      }
      if (this.$refs[`pearlieSueScene${this.currentScene}`]) {
        this.$refs[`pearlieSueScene${this.currentScene}`].speak()
      }
      if (this.currentScene === 3){
        this.choirTimeout = setTimeout(()=>{
          this.$refs[`choirScene3`].play3()
        }, 6000)
      }
      if (this.currentScene === 6){
        this.choirTimeout = setTimeout(()=>{
          this.$refs[`choirScene6`].play6()
        }, 6000)
      }
      if (this.currentScene === 10){
        this.choirTimeout = setTimeout(()=>{
          this.$refs[`choirScene10`].play10()
        }, 6000)
      }
      if (this.$refs[`compassScene${this.currentScene}`]) {
        this.$refs[`compassScene${this.currentScene}`].spin()
      }
    },
  }, 
}
</script>

<style lang="scss">
body {
  background-color: #FFF;
}
</style>
